import React from "react";
import Icon from "./Icon";
import type { IconProps } from "./IconProps";

const CloseIcon: React.FC<IconProps> = ({ className, title }) => {
  const svgPath = (
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 18 18 6M6 6l12 12"
    />
  );

  return (
    <Icon
      svgPath={svgPath}
      className={className}
      title={title}
      fill="none"
      strokeWidth={1.5}
    />
  );
};

export default CloseIcon;
